module.exports = __webpack_public_path__ + "static/media/textlayer_color.1c323d45.jpg";